import '../scss/style.scss';
import { initAnimations } from './modules/animations.js';
import { initCookies } from './modules/cookies.js';

// Cette entrée porte la feuille de styles du front, met en place les animations
// d’entrée au défilement et rejoue le consentement aux traceurs. L'en-tête est
// collant en CSS et les questions fréquentes reposent sur <details> : rien
// d'autre n'a besoin de JavaScript ici.

// Le consentement passe avant tout le reste : une balise posée par un tiers ne
// doit jamais partir sur l'état « refusé » alors que l'usager a déjà accepté.
initCookies();

document.addEventListener( 'DOMContentLoaded', initAnimations );

/*
 * Rustine de développement, inerte en production.
 *
 * En `npm run start`, Vite ne pose pas de <link> : il injecte la feuille dans
 * une balise <style data-vite-dev-id> après coup, en JavaScript. Or le routeur
 * de l'Interactivity API, quand une pastille de filtre remplace une liste sans
 * recharger, compare le <head> au document qu'il vient de chercher et DÉSACTIVE
 * les feuilles qui n'y figurent pas. Celle de Vite n'y figure évidemment pas :
 * gouttières, cartes et tout le socle disparaissent jusqu'au prochain
 * rechargement complet.
 *
 * En production la feuille est un vrai <link> présent dans chaque document :
 * le routeur la garde, l'attribut `data-vite-dev-id` n'existe pas, et rien de
 * ce qui suit ne s'exécute.
 */
if ( document.querySelector( 'style[data-vite-dev-id]' ) ) {
	const reactiver = () => {
		document.querySelectorAll( 'style[data-vite-dev-id]' ).forEach( ( balise ) => {
			if ( balise.sheet?.disabled ) {
				balise.sheet.disabled = false;
			}
		} );
	};

	// Le routeur désactive après avoir remplacé la région : on repasse derrière.
	new window.MutationObserver( reactiver ).observe( document.head, {
		attributes: true,
		childList: true,
		subtree: true,
	} );

	window.addEventListener( 'popstate', reactiver );
}
